import { UserAssignLicenseDialogComponent } from './user-assign-license-dialog/user-assign-license-dialog.component';
import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { LicenseAssignment } from 'src/app/models/license/license-assignment';
import { LicenseService } from 'src/app/services/license.service';
import { ApiError } from 'src/app/models/api/api-error.model';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import {
  Input,
  inject,
  Component,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-user-licenses-data',
  templateUrl: './user-licenses-data.component.html',
})
export class UserLicensesDataComponent implements OnChanges {
  private _baseComponentService = inject(BaseComponentService);
  private _licenseService: LicenseService = inject(LicenseService);
  private _authService: AuthService = inject(AuthService);
  private _userService: UserService = inject(UserService);

  protected loading: boolean = true;
  protected error?: ApiError;

  @Input() userId?: string;
  @Input() startLoading: boolean = false;

  protected licenseAssignmentsListing: LicenseAssignment[] = [];
  protected sectionsState$ = this._authService.sectionsState$;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['startLoading'].currentValue &&
      !changes['startLoading'].previousValue
    ) {
      this.getData();
    }
  }

  async getData() {
    this.loading = true;
    this.error = undefined;
    this._userService
      .getLicensesAssignmentsListing(this.userId)
      .subscribe({
        next: (response) => {
          this.licenseAssignmentsListing = response.data.map(
            (json: any) => new LicenseAssignment(json)
          );
        },
        error: (error) => {
          this.error = new ApiError(error);
          console.error('Licenses Assignments Listing ERROR:', error);
        },
      })
      .add(() => (this.loading = false));
  }

  async showLicenseAssignmentDialog(licenseAssignmentId?: string) {
    const dialogSize = '600px';
    const dialogRef = this._baseComponentService.dialog.open(
      UserAssignLicenseDialogComponent,
      {
        maxWidth: dialogSize,
        minWidth: dialogSize,
        data: {
          userId: this.userId,
          licenseAssignmentId,
        },
        autoFocus: false,
        restoreFocus: false,
      }
    );
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult === true) {
        this.getData();
      }
    });
  }

  showDeleteDialog(licenseAssignmentId?: string) {
    this._baseComponentService
      .confirmDeletion({
        message: 'Confermi di voler eliminare questa assegnazione?',
        details: '(Non sarà possibile annullare questa operazione)',
        destructive: true,
      })
      .subscribe((dialogResult) => {
        if (dialogResult === true) {
          this._licenseService
            .deleteLicenseAssignment(licenseAssignmentId)
            .subscribe({
              next: (_) => this.getData(),
              error: (error: unknown) => {
                console.error('Delete License Assignment ERROR:', error);
                this._baseComponentService.showErrorDialog({
                  error: new ApiError(error),
                });
              },
            });
        }
      });
  }
}
